import { useState } from "react";
import { FormControl, TextField } from "@mui/material";

interface IInputEditCellProps {
	error: boolean;
	value: string;
	disabled?: boolean;
	editComplete?: (value: string) => void;
}

const InputEditCell = (props: IInputEditCellProps) => {
	const { error, disabled = false, editComplete } = props;
	const [value, setValue] = useState(props?.value || "");

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const inputValue = event.target.value;
		if (editComplete) {
			editComplete(inputValue);
		}
		setValue(inputValue);
	};

	return (
		<FormControl fullWidth>
			<TextField
				variant="outlined"
				value={value}
				inputProps={{
					maxLength: 300,
				}}
				className="text-input-table"
				onChange={handleChange}
				error={!value || error}
				disabled={disabled}
			/>
		</FormControl>
	);
};

export default InputEditCell;
